export function arrayRemoveAt(array, index) {
  if (index < 0) {
    return array;
  }
  return [...array.slice(0, index), ...array.slice(index + 1)];
}

export function arrayAdd(array, item) {
  return [...array, item];
}

export function arrayUpdateAt(array, index, item) {
  if (index >= 0) {
    return [...array.slice(0, index), item, ...array.slice(index + 1)];
  }
  return array;
}

export function arrayAddAt(array, index, item) {
  if (index >= 0) {
    return [...array.slice(0, index), item, ...array.slice(index)];
  }
  return array;
}

export function arrayRemoveItem(array, item) {
  const index = array.indexOf(item);
  if (index >= 0) {
    return [...array.slice(0, index), ...array.slice(index + 1)];
  }
  return array;
}

export function arrayToggleItem(array, item) {
  const index = array.indexOf(item);
  if (index >= 0) {
    return [...array.slice(0, index), ...array.slice(index + 1)];
  }
    return arrayAdd(array, item);
}

export function arrayAddUnique(array, item) {
  if (array.includes(item)) {
    return array;
  }
  return [...array, item];
}
